import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Start the video call',
    decline: 'No, thank you',
    description:
      'We would like to gather your feedback about your account opening through a video call with our User Experience researcher.',
    incentive: '1 additional month offered for your participation',
    intercomMessage:
      'Hi, I would like to take part in improving the Shine experience.',
    terms: {
      error: 'Please accept the terms',
      label: 'I consent to share my screen and turn on my camera',
    },
    title: 'Help us improve the Shine experience',
  },

  fr: {
    cta: 'Démarrer l’appel vidéo',
    decline: 'Non merci',
    description:
      'Nous aimerions recueillir vos impressions pendant votre ouverture de compte à travers un appel vidéo avec notre responsable Expérience Utilisateur·ice.',
    incentive:
      '1 mois d’abonnement supplémentaire vous est offert pour votre participation.',
    intercomMessage:
      'Bonjour, je suis disponible pour participer à l’amélioration de l’experience Shine.',
    terms: {
      error: 'Acceptez les conditions',
      label: 'J’autorise à partager mon écran et activer ma camera',
    },
    title: 'Participez à l’amélioration de l’expérience Shine',
  },
} as const);

export default locales;
